import React, {forwardRef} from 'react';
import {PagoDeduccion} from "./PagoDeduccion";
import PropTypes from "prop-types";


export const ContainerPrintAll =forwardRef(({datapagos}, ref)  => {

    return (
        <div ref={ref}>
            {datapagos.length > 0 && datapagos.map((dataPago, i) => <div key={i} className='mt-5 mb-10 px-8'>
                <PagoDeduccion
                    datapago={dataPago.datos}
                    prestaciones={dataPago.prestaciones}
                />
                <hr  style={{borderBottomWidth: '30px'}} className="mt-20 border-white"/>
            </div>)}
        </div>
    );
});



ContainerPrintAll.prototype = {
    datapagos: PropTypes.array,
}

ContainerPrintAll.defaultProps = {
    datapagos: [],
}


